import { mapSRLocationField } from 'utils/mapSRLocationField';

export const mapSRArrayLocationFields = (response: ServiceRequestUnmappedResponse[]): ServiceRequest[] => {
  return response.map(request => mapSRLocationField(request));
};
